{
  "0_ALREADY_EXISTS": "\"{0}\" sudah ada.",
  "0_OF_1": "{0} dari {1}",
  "ACCOUNT_ID": "ID Akun",
  "ADD": "Tambah",
  "ADD_REMOVE_FIELDS": "Tambah/hapus field",
  "AN_ERROR_OCCURED": "Terjadi kesalahan",
  "APPLY": "Terapkan",
  "APPLY_CHANGES": "Terapkan perubahan",
  "ATTACH": "Lampirkan",
  "ATTACH_AS_LINK": "Lampirkan sebagai Tautan",
  "ATTACHING": "Melampirkan...",
  "AUTOMATICALLY_RENAME": "Ganti nama secara otomatis",
  "BACK": "Kembali",
  "BROWSE": "Telusuri",
  "CANCEL": "Batal",
  "CHARACTER_COUNT": "Jumlah karakter:",
  "CLOSE": "Tutup",
  "CLOUD": "Cloud",
  "COMMENT": "Komentar",
  "CONFIGURE_REPOSITORY_SETTINGS": "Konfigurasikan Pengaturan Repository",
  "COULD_NOT_SAVE_0": "Tidak dapat menyimpan \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Tidak dapat menyimpan \"{0}\". Jenis file tidak didukung.",
  "DATA": "Data",
  "DATE": "Tanggal",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Field tanggal harus dalam format {0}.",
  "DATE_PROVIDED_IS_INVALID": "Tanggal yang diberikan tidak valid.",
  "DATE_TIME": "Tanggal/Waktu",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Field tanggal/waktu harus dalam format {0}.",
  "DEFAULT_FOLDER": "<Default Folder>",
  "DETAILS": "Detail",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Apakah Anda ingin menerapkan perubahan field Anda?",
  "DOCUMENT_NAME_IS_EMPTY": "Nama dokumen kosong",
  "DRAG_DROP_FILE": "Seret dan lepas file",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Entri bernama '{0}' sudah ada di folder ini. Silakan pilih nama yang berbeda.",
  "ENTRY_ID": "ID Entri",
  "ENTRY_NAME": "Nama Entri",
  "ENTRY_NOT_FOUND": "Entri tidak ditemukan.",
  "ERROR_DOWNLOADING_DOCUMENT": "Kesalahan saat mengunduh dokumen.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Terjadi kesalahan saat menghubungkan ke server.",
  "ERROR_SAVING": "Kesalahan saat menyimpan:",
  "FAILED_TO_OPEN_FOLDER": "Gagal membuka folder",
  "FAILED_TO_SAVE_COLON": "Gagal menyimpan:",
  "FAILED_TO_SAVE_PERIOD": "Gagal menyimpan.",
  "FEEDBACK": "Masukan",
  "FIELDS": "Field",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "File ini melebihi ukuran file maksimum sebesar 25MB.",
  "FILE_EXTENSION": "Ekstensi File",
  "FILE_LOCKED": "File terkunci.",
  "FILE_MODIFIED": "File Dimodifikasi",
  "FILE_NAME": "Nama File",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Nama file tidak boleh mengandung backslash",
  "FOLDER": "Folder",
  "INTEGER": "Bilangan bulat",
  "LIST": "Daftar",
  "LOADING": "Memuat...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Field panjang harus berupa bilangan bulat antara 0 dan 3.999.999.999",
  "LONG_INTEGER": "Bilangan bulat panjang",
  "NAME": "Nama",
  "NAME_CONFLICT": "Konflik Nama",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Perlu bantuan masuk? Hubungi Administrator Laserfiche Anda untuk bantuan.",
  "NEW_FOLDER": "Folder Baru",
  "NO": "Tidak",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Tidak ada field tambahan yang ditetapkan",
  "NO_FOLDER_SELECTED": "Tidak ada folder yang dipilih.",
  "NO_MATCHING_ENTRIES_FOUND": "Tidak ditemukan entri yang cocok",
  "NO_MATCHING_FIELDS_FOUND": "Tidak ditemukan field yang cocok.",
  "NO_TEMPLATE_ASSIGNED": "Tidak ada template yang ditetapkan",
  "NOT_AVAILABLE_WITH_TOKENS": "Tidak tersedia dengan token",
  "NUMBER": "Angka",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Field angka harus berupa angka yang valid",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Satu atau lebih field tidak valid.",
  "OPEN": "Buka",
  "OPEN_IN_LASERFICHE": "Buka di Laserfiche",
  "OPTIONAL": "Opsional",
  "OR": "atau",
  "PARENT_FIELD": "Field Induk",
  "PARENT_ID": "ID Induk",
  "PARENT_NAME": "Nama Induk",
  "PLEASE_SELECT_A_FOLDER": "Silakan pilih folder",
  "REASON_FOR_DOWNLOADING": "Alasan Mengunduh",
  "REFRESH": "Segarkan",
  "REMOVE": "Hapus",
  "REMOVE_REPOSITORY": "Hapus Repository?",
  "REPOSITORY": "Laserfiche Repository",
  "REPOSITORY_COUNT": "Jumlah Repository",
  "REPOSITORY_ID": "ID Repository",
  "REPOSITORY_NAME": "Nama Repository",
  "REQUIRED": "Wajib",
  "REQUIRED_FIELD_IS_EMPTY": "Field wajib kosong",
  "SAVE_CHANGES": "Simpan Perubahan",
  "SAVE_TO_LASERFICHE": "Simpan ke Laserfiche",
  "SAVED_TO_LASERFICHE": "Disimpan ke Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Disimpan ke Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Disimpan dengan metadata yang hilang:",
  "SAVING": "Menyimpan...",
  "SEARCH_FIELDS": "Cari field",
  "SELECT": "Pilih",
  "SELECT_REASON": "Pilih alasan",
  "SELF_HOSTED": "Self-Hosted",
  "SESSION_COUNT": "Jumlah Sesi",
  "SETTINGS": "Pengaturan",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Field pendek harus berupa bilangan bulat antara 0 dan 64999",
  "SIGN_IN": "Masuk",
  "SIGN_IN_TO_LASERFICHE": "Masuk ke Laserfiche",
  "SIGN_OUT": "Keluar",
  "SIGNING_IN": "Masuk...",
  "SIGNING_OUT": "Keluar...",
  "SKIP_THIS_FILE": "Lewati file ini",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Terjadi kesalahan. Silakan coba lagi nanti.",
  "SUBMIT": "Kirim",
  "SUGGESTION": "Saran",
  "TEMPLATE": "Template_Name",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Template gagal dimuat.",
  "TEXT": "Teks",
  "THANK_YOU_FOR_SUBMISSION": "Terima kasih atas pengiriman Anda!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Field ini memiliki panjang maksimum yang diizinkan sebanyak {0} karakter.",
  "THIS_FOLDER_IS_EMPTY": "Folder ini kosong.",
  "TIME": "Waktu",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Field waktu harus dalam format {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Tidak dapat memuat semua field:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Tidak dapat mengambil informasi repository:",
  "UNKNOWN_ERROR": "Kesalahan Tidak Dikenal.",
  "USER_NAME": "Nama Pengguna",
  "YES": "Ya"
}
